import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Conteudo from "./pages/Conteudo/Conteudo";
import Rodape from "./components/Rodape/Rodape";
import Topo from "./components/Topo/Topo";
import Contato from "./pages/Contato/Contato";
import Business from "./pages/Business/Business";
import BodyClass from "./components/BodyClass/BodyClass";
import EssentiaExperience from "./pages/EssentiaExperience/EssentiaExperience";
import Qualidade from "./pages/Qualidade/Qualidade";
import PageFlip from "./pages/PageFlip/PageFlip";
import Carreiras from "./pages/Carreiras/Carreiras";
import NotFound from "./pages/NotFound/NotFound";

function App() {
  return (
    <Router>
      <div>
        <Topo />
        <BodyClass />
        <Routes>
          <Route path="/" element={<Conteudo />} />
          <Route path="/contatos" element={<Contato />} />
          <Route path="/business" element={<Business />} />
          <Route path="/essentiaexperience" element={<EssentiaExperience />} />
          <Route path="/qualidade" element={<Qualidade />} />
          <Route path="/journal" element={<PageFlip />} />
          <Route path="/carreiras" element={<Carreiras />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Rodape />
      </div>
    </Router>
  );
}

export default App;
